import askForLeavingWithoutSavingChanges
    from '../../../../modules/core/helpers/routing/ask-for-leaving-without-saving-changes';

export default class AbstractEditorController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        askForLeavingWithoutSavingChanges(this);

        this.angularState = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.depositService = this.injector.get('Deposit');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.navService = this.injector.get('NavService');
        this.navHelper = this.injector.get('NavHelper');

        this.store = null;
        if (this.stateParams.store) {
            this.store = this.stateParams.store;
        }

        this.deposits = {
            relationTypes: {}
        };
        this.changeRelationTypeEnabled = true;
        this.loading = true;

        this.model = {
            title: '',
            template: '',
            relation_type: null,
            pdf_options: {
                'page-height': '297mm',
                'page-width': '210mm',
                'margin-top': '0mm',
                'margin-left': '0mm',
                'margin-bottom': '0mm',
                'margin-right': '0mm'
            }
        };

        this._updateDetailsNav();
        this._setupAceInformation();
    }

    back() {
        this.angularState.go('app.documents.templates.index');
    }

    _loadModel() {
        return this.api.get(`documents/templates/${this.stateParams.id}`).then((response) => {
            this.model = _.cloneDeep(response.data.data);
            this._updateDetailsNav();
        }, () => {
            this.alert.error(this.translate.instant('documents.templates.general_errors.model_load_error.title'), this.translate.instant('documents.templates.general_errors.model_load_error.message'));
        });
    }

    _loadAndStoreDeposits() {
        return this.injector.get('$q').all([
            this.depositService.getRemoteDeposit('documents', 'template_relation_types', []).then((value) => {
                this.deposits.relationTypes = _.cloneDeep(value);

                if (_.isNull(this.model.relation_type)) {
                    this.model.relation_type = _.first(Object.keys(this.deposits.relationTypes));
                }

                return value;
            })
        ]);
    }

    _setupAceInformation() {
        this.templateAce = {
            type: 'ace',
            aceOptions: {
                useWrapMode: false,
                highlightActiveLine: false,
                showGutter: false,
                theme: 'chrome',
                mode: 'twig',
                require: [
                    'ace/ext/language_tools'
                ],
                advanced: {
                    enableBasicAutocompletion: true,
                    enableSnippets: true,
                    enableLiveAutocompletion: true
                },
                onLoad: function (editor) {
                }
            }
        };
    }

    _updateDetailsNav() {
        this.navHelper.setTranslationsParamsForEntry('addressbook.documents.templates.details', {
            name: this.loading ? this.translate.instant('general.verbs.loading_dot') : this.model.title
        });
    }
}

AbstractEditorController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/controllers/abstract-editor-controller.js